import { render } from "./ForumUserHistory.vue?vue&type=template&id=9c259dcc&scoped=true"
import script from "./ForumUserHistory.vue?vue&type=script&lang=js"
export * from "./ForumUserHistory.vue?vue&type=script&lang=js"

import "quill-emoji/dist/quill-emoji.css?vue&type=style&index=0&lang=css"
import "./ForumUserHistory.vue?vue&type=style&index=1&id=9c259dcc&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c259dcc"]])

export default __exports__